<template>
    <div>
        <h5>Countdowns</h5>
        <div class="mb-3 mt-3">
            <div v-for="(countdown, index) in sale_send" class="countdown-holder w-100">
                <div class="row">
                    <div class="col-3">
                        <div class="form-group">
                            <label>Starts at*</label>
                            <datetime placeholder="Starts date" v-model="countdown.starts_at" input-class="form-control" input-id="startDate" type="datetime" format="dd/MM/y HH:mm:ss" @close="changed_array(countdown.id)"></datetime>
                        </div>
                        <div class="form-group">
                            <label>Ends at*</label>
                            <datetime placeholder="Ends date" v-model="countdown.ends_at" input-class="form-control" input-id="endDate" type="datetime" format="dd/MM/y HH:mm:ss" @close="update_countdowns(), changed_array(countdown.id)"></datetime>
                        </div>
                        <div class="position-relative colour-picker mb-2">
                            <div class="d-flex align-items-center">
                                <div class="ml-auto mr-2">
                                    Background: 
                                </div>
                                <div style="width:100px;" class="mr-2">
                                    <input type="text" v-model="countdown.data[0].value" @keyup="changed_array(countdown.id)" class="form-control">
                                </div>
                                <div style="width:36px;height:36px;" :style="'background:' + countdown.data[0].value" class="border border-secondary"></div>
                            </div>
                        </div> 
                        <div class="position-relative colour-picker">
                            <div class="d-flex align-items-center">
                                <div class="ml-auto mr-2">
                                    Text Colour: 
                                </div>
                                <div style="width:100px;" class="mr-2">
                                    <input type="text" v-model="countdown.data[1].value" @keyup="changed_array(countdown.id)" class="form-control">
                                </div>
                                <div style="width:36px;height:36px;" :style="'background:' + countdown.data[1].value" class="border border-secondary"></div>
                            </div>
                        </div>                    
                    </div>
                    <div class="col-auto">
                        <div>Preview</div>
                        <div>
                            <vue-countdown :time="countdown.end" :tag="'div'" class="countdown-preview text-center" :style="'background:' + countdown.data[0].value + ';color:' +countdown.data[1].value">
                                <template slot-scope="props">
                                    <div class="number-wrapper" v-if="props.days > 0">
                                        <div class="number">{{ props.days }}</div>
                                        <div class="time-period">days</div>
                                    </div>
                                    <div class="clock-spacer" v-if="props.days > 0">:</div>
                                    <div class="number-wrapper">
                                        <div class="number">{{ props.hours }}</div>
                                        <div class="time-period">hours</div>
                                    </div>
                                    <div class="clock-spacer">:</div>
                                    <div class="number-wrapper">
                                        <div class="number">{{ props.minutes }}</div>
                                        <div class="time-period">minutes</div>
                                    </div>
                                    <div class="clock-spacer">:</div>
                                    <div class="number-wrapper">
                                        <div class="number">{{ props.seconds }}</div>
                                        <div class="time-period">seconds</div>
                                    </div>
                                </template>
                            </vue-countdown>
                        </div>
                        <button class="btn btn-danger btn-sm mt-2" @click="delete_countdown(index, countdown.id)"><i class="far fa-trash-alt"></i>&nbsp; Delete countdown</button>
                    </div>
                </div>
            </div>
            <button class="btn btn-info mt-2" @click="add_countdown();"><i class="fas fa-plus"></i>&nbsp; Add countdown</button>        
        </div>
        <div>
            <button class="btn btn-danger mr-1" @click="closeSection"><i class="far fa-times-circle"></i>&nbsp; Close</button>
            <button class="btn btn-primary mr-1" @click="save()"><i class="far fa-save"></i>&nbsp; Save</button>
            <button class="btn btn-success" @click="save('close')"><i class="fas fa-save"></i>&nbsp; Save &amp; close</button>
        </div>
        <loader :loading="loading"></loader>
    </div>
</template> 

<script>

import moment from 'moment';
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import VueCountdown from '@chenfengyuan/vue-countdown';
import loader from './loader.vue';

export default {

    components: {
        moment,
        datetime: Datetime,
        VueCountdown,
        loader
    },

    data() {
        return {
            sale_send: {},
            changed: [],
            deleted: [],
            axios_array: [],
            loading: false,
            load_count: 0,
        };
    },

    props: {
        sale: Object,
    },

    mounted(){
        this.sale_send = this.sale.countdowns;

        this.update_countdowns();
         
        history.pushState({page: 0}, "", window.location.pathname + "?page=countdowns");  
    },

    methods: {
        save(close) {
            let colourData;
            this.loading_count()
            if(this.load_count > 0){
                this.loading = true;
            } else if(close){
                this.closeSection();
            }
            if(this.deleted.length > 0){
                for(let del in this.deleted){
                    this.axios_array.push(axios.delete('/sales/' + this.sale.id + '/countdowns/' + this.deleted[del]))
                }
            }
            for(let countdown in this.sale_send){
                colourData = {
                    background: this.sale_send[countdown].data[0].value,
                    foreground: this.sale_send[countdown].data[1].value,
                }
                if(this.changed.includes(this.sale_send[countdown].id) && this.sale_send[countdown].id){
                    this.axios_array.push(axios.patch('/sales/' + this.sale.id + '/countdowns/' + this.sale_send[countdown].id,{
                        starts_at: this.db_date(this.sale_send[countdown].starts_at),
                        ends_at: this.db_date(this.sale_send[countdown].ends_at),                        
                        data: colourData,
                    }))
                } else if(!this.sale_send[countdown].id){
                    this.axios_array.push(axios.post('/sales/' + this.sale.id + '/countdowns', 
                    {
                        starts_at: this.db_date(this.sale_send[countdown].starts_at),
                        ends_at: this.db_date(this.sale_send[countdown].ends_at),                        
                        data: colourData,
                        headers: {
                            'content-type': 'multipart/form-data',
                        },
                    }))
                }
            }
            axios.all(this.axios_array)            
            .then(function (responses){   
                if(responses.length > 0){   
                    axios.get('/sales/' + this.sale.id)
                    .then(function (response) {
                        this.sale_send = response.data.sale.countdowns;
                        this.check_load(close);                        
                        this.update_countdowns();             
                    }.bind(this))
                    .catch(function (error) {
                        alert(error);
                    })                
                }
            }.bind(this));
        },
        update_countdowns(){
            for(let countdown in this.sale_send){
                Vue.set( this.sale_send[countdown], 'end', moment(this.sale_send[countdown].ends_at).diff(moment()) );
                this.sale_send[countdown].starts_at = this.format_dates(this.sale_send[countdown].starts_at);
                this.sale_send[countdown].ends_at = this.format_dates(this.sale_send[countdown].ends_at);                 
                Vue.set( this.sale_send[countdown], 'end', moment(this.sale_send[countdown].ends_at).diff(moment()) );
                if(moment() > moment(this.sale_send[countdown].ends_at)){
                    Vue.set( this.sale_send[countdown], 'end', 0 );
                }
            }
        },
        add_countdown(){
            this.sale_send.push(
                {
                    colourshow: false,
                    data: {
                        0: {
                            key: "background",
                            value: "#454545",
                        },
                        1: {
                            key: "background",
                            value: "#ffffff",
                        },
                    },
                    ends_at: this.format_dates(moment().endOf('day')),
                    starts_at: this.format_dates(moment().startOf('day')),
                }
            );
            this.update_countdowns();
        },
        changed_array(id){
            if(id){
                if(!this.changed.includes(id)){
                    this.changed.push(id);
                }
            }
        },
        delete_countdown(index, id){
            this.sale_send.splice(index, 1);
            if(id){
                this.deleted.push(id);
            }
        },
        closeSection (event) {
            history.pushState({page: 0}, "", window.location.pathname); 
            this.$emit('closeChild', false);
        },
        loading_count(){
            let loadCount = this.changed.length + this.deleted.length;
            for(let countdown in this.sale_send){
                if(!this.sale_send[countdown].id){
                    loadCount++;
                }
            }
            this.load_count = loadCount;
        },
        check_load(close){
            this.loading = false;
            this.changed = [];
            this.deleted = [];
            this.axios_array = [];
            if(close == 'close'){
                this.closeSection();
            }
        },
        format_dates: function(date){
            return moment(date).format('YYYY-MM-DDTHH:mm:ss');
        },
        db_date: function (date) {
            return moment(date).format('YYYY-MM-DD HH:mm:ss');
        },
    },
};
</script>